<!--
 * @Author: your name
 * @Date: 2020-05-28 13:43:51
 * @LastEditTime: 2020-08-17 13:59:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-purchase\components\scroll-follow\index.vue
-->
/**
* Created by Sandon on 2019-05-30.
*/
<template>
  <div
    class="sy-scroll-follow"
    ref="scroll-follow"
    :style="{width: `${width}px`, height: `${height}px`}">
    <div
      class="sy-scroll-follow-wrap"
      :class="{'fixed': isButtonsFixed}"
      :style="{width: `${width}px`, height: `${height}px`}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import {offset} from '../../../utils/dom'
  // import throttle from 'lodash/throttle'

  export default {
    name: 'index',
    props: {
      width: {
        type: String,
        default: '1150'
      },
      height: {
        type: String,
        default: '65'
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isButtonsFixed: false,
        scrollHandler: null
      }
    },
    watch: {
      'disabled': function () {
        if (this.disabled) {
          this.isButtonsFixed = false
          this.scrollHandler = null
        } else {
          this._initScrollHandler()
        }
      }
    },
    mounted () {
      !this.disabled && this._initScrollHandler()
    },
    updated () {
      this.update()
    },
    beforeDestroy () {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler)
      }
    },
    methods: {
      _initScrollHandler () {
        const self = this
        let scrollFollow = this.$refs['scroll-follow']
        const $win = scrollFollow.ownerDocument.defaultView

        let handler = function () {
          const objOffsetAndHeight = offset(scrollFollow).top + scrollFollow.getBoundingClientRect().height
          const scrollAndWinHeight = $win.pageYOffset + $win.innerHeight
          self.isButtonsFixed = scrollAndWinHeight < objOffsetAndHeight
        }
        this.scrollHandler = handler
        // this.scrollHandler = throttle(handler, 100)
        window.addEventListener('scroll', this.scrollHandler)
        this.scrollHandler()
      },
      // 对外接口
      update () {
        this.scrollHandler && this.scrollHandler()
      }
    }
  }
</script>

<style scoped lang="scss">
  .sy-scroll-follow-wrap{
    &.fixed{
      position: fixed;
      bottom: 0;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      z-index: 2;
    }
  }
</style>
